// import utils
import dayjs from 'dayjs';

export const dateSortComparator = (a?: string | Date, b?: string | Date) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return dayjs(a).isBefore(dayjs(b)) ? -1 : 1;
};
